import * as ActionTypes from "../Types/ActionTypes";

const initialState = {
  isLoading: false,
  errMess: null,
  reports: [],
  singleReport: null,
};

const InventoryReport = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.INVENTORY_VALUATION_LOADING:
      return {
        ...state,
        isLoading: true,
        errMess: null,
        reports: [],
        singleReport: null,
      };

    case ActionTypes.INVENTORY_VALUATION_FAILED:
      return {
        ...state,
        isLoading: false,
        errMess: action.payload,
        reports: [],
        singleReport: null,
      };

    case ActionTypes.FETCH_INVENTORY_VALUATION_REPORTS:
      return {
        ...state,
        isLoading: false,
        errMess: null,
        reports: action.payload,
        singleReport: null,
      };

    case ActionTypes.FETCH_SINGLE_INVENTORY_VALUATION_REPORT:
      return {
        ...state,
        isLoading: false,
        errMess: null,
        reports: state.reports,
        singleReport: action.payload,
      };

    default:
      return state;
  }
};

export default InventoryReport;